import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {CommonResponse} from '../interfaces/home';

@Injectable({
  providedIn: 'root'
})
export class AppReviewService {

  constructor(private http: HttpClient) { }
  baseUrl = environment.baseUrl+'AppReview/';
  // fetch all AppReview in the database
  allAppReviewData(): Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl);
  }
  getAppReview(id: any):Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl +id);
  }
  postAppReview(data: any){
    return this.http.post(this.baseUrl, data);
  }
  deleteAppReview(id: any){
    return this.http.delete(this.baseUrl +id);
  }
  updateAppReview(id: any, data: any){
    return this.http.put(this.baseUrl +id, data);
  }
}
